var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderlogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FFF5ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.9253 22.0896L16.9254 22.0889C17.0427 21.0992 17.1791 20.3686 17.6076 19.8595C18.0094 19.3823 18.7655 19 20.3989 19H27.5989C29.2322 19 29.9884 19.3823 30.3901 19.8595C30.8187 20.3686 30.955 21.0992 31.0724 22.0889L31.0724 22.0896L31.8224 28.3396L31.9724 29.5896L31.9727 29.592L31.9877 29.712L32.0016 29.8231C32.1004 30.9419 31.9417 31.841 31.4554 32.4562C30.9811 33.0561 30.1022 33.5 28.4889 33.5H19.5089C17.8446 33.5 16.9615 33.0267 16.4974 32.3923C16.016 31.7342 15.8859 30.7724 16.0254 29.589C16.0254 29.5889 16.0254 29.5887 16.0254 29.5885L16.9253 22.0896Z",
    fill: "#F85417",
    stroke: "#F85417"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 20.25C27.8661 20.25 27.75 20.1339 27.75 20V16.5C27.75 15.8555 27.548 15.2809 27.1336 14.8664C26.7191 14.452 26.1445 14.25 25.5 14.25H22.5C21.8555 14.25 21.2809 14.452 20.8664 14.8664C20.452 15.2809 20.25 15.8555 20.25 16.5V20C20.25 20.1339 20.1339 20.25 20 20.25C19.8661 20.25 19.75 20.1339 19.75 20V16.5C19.75 15.665 20.0408 14.9838 20.5123 14.5123C20.9838 14.0408 21.665 13.75 22.5 13.75H25.5C26.335 13.75 27.0162 14.0408 27.4877 14.5123C27.9592 14.9838 28.25 15.665 28.25 16.5V20C28.25 20.1339 28.1339 20.25 28 20.25Z",
    fill: "#F85417",
    stroke: "#F85417"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 28.7798H31.8764L31.9364 29.2798H20C19.8661 29.2798 19.75 29.1636 19.75 29.0298C19.75 28.8903 19.8618 28.7798 20 28.7798Z",
    fill: "#F85417",
    stroke: "#F85417"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderlogo);
export default __webpack_public_path__ + "static/media/orderlogo.48e947d7ea655052c6096b87b66128f1.svg";
export { ForwardRef as ReactComponent };